import {
    createSystem,
    defaultConfig,
    defineConfig,
    defineRecipe,
    defineSlotRecipe,
} from "@chakra-ui/react";

const labelFloatingStyleProps = {
    color: "fg !important",
    top: "-3",
    insetStart: "2",
};

const buttonRecipe = defineRecipe({
    // The styles all buttons have in common
    base: {
        borderRadius: "base", // <-- border radius is same for all variants and sizes
    },
    variants: {
        size: {
            // Two sizes: sm and md
            sm: {
                fontSize: "sm",
                px: 4, // <-- px is short for paddingLeft and paddingRight
                py: 3, // <-- py is short for paddingTop and paddingBottom
            },
            md: {
                fontSize: "md",
                px: 6, // <-- these values are tokens from the design system
                py: 4, // <-- these values are tokens from the design system
            },
        },
    },
    // The default size and variant values
    defaultVariants: {
        size: "md",
    },
});
const inputRecipe = defineRecipe({
    base: {
        _placeholder: {
            opacity: 0.8,
            color: "#333",
        },
    },
});
const linkRecipe = defineRecipe({
    base: {
        _hover: {
            textDecoration: "none",
        },
    },
});
const fieldSlotRecipe = defineSlotRecipe({
    slots: ["root", "label", "input", "textarea"],
    variants: {
        variant: {
            floating: {
                root: {
                    position: "relative",
                    // ----Styles applied to the label (floating state)----
                    // When the input is focused:
                    "&:focus-within .chakra-field__label": { ...labelFloatingStyleProps },
                    // When the input has a value:
                    "&:has(input:not(:placeholder-shown)) .chakra-field__label": {
                        ...labelFloatingStyleProps,
                    },
                    // When a child `Select` has a selected value
                    "&:has(.chakra-select__valueText:not(:empty)) .chakra-field__label": {
                        ...labelFloatingStyleProps,
                    },
                },
                label: {
                    // Styles applied to the label when the input is not focused (default state)
                    pos: "absolute",
                    bg: "bg",
                    px: "0.5",
                    top: "2.5",
                    insetStart: "3",
                    fontWeight: "normal",
                    pointerEvents: "none",
                    transition: "position",
                },
            },
        },
    },
});
const tooltipSlotRecipe = defineSlotRecipe({
    slots: ["root", "content", "arrow", "arrowTip"],
    variants: {
        variant: {
            white: {
                content: {
                    bg: "white",
                    color: "black",
                    border: "1px solid",
                    borderColor: "gray.200",
                    px: "2px !important",
                    py: "1px !important",
                    rounded: "md",
                    boxShadow: "md",
                },
                arrowTip: {
                    backgroundColor: "white !important",
                    borderColor: "gray.200",
                },
            },
        },
    },
});
const switchSlotRecipe = defineSlotRecipe({
    slots: ["root"],
    base: {
        root: {
            colorPalette: "yellow",
        },
    },
});

const customTheme = createSystem(
    defaultConfig,
    defineConfig({
        theme: {
            recipes: {
                button: buttonRecipe,
                input: inputRecipe,
                link: linkRecipe,
            },
            slotRecipes: {
                field: fieldSlotRecipe,
                tooltip: tooltipSlotRecipe,
                switch: switchSlotRecipe,
            },
            tokens: {
                colors: {
                    brand: {
                        600: { value: "#EDBE00" },
                        500: { value: "#FFCD00" },
                    },
                    accent: {
                        600: { value: "#05253A" },
                        500: { value: "#002B49" },
                    },
                },
                fonts: {
                    heading: { value: "Poppins" },
                    body: { value: "Poppins" },
                },
                shadows: {
                    outline: { value: "0 0 0 3px rgba(255,205,0, 0.6)" },
                },
            },
        },
        globalCss: {
            a: {
                color: "#000",
            },
        },
    })
);

// REQUIRED for Chakra v3 + typegen
export default customTheme;
